import React from "react"
import {useSelector, useDispatch} from "react-redux"

import ToggleProdBtn from "../ToggleProdBtn/ToggleProdBtn"

import "./toggleproductcontainer.scss"

import {
  setProduct2dActivePart,
  setProduct2dCanvasState,
  clearLeftWorkAreaState,
  clearActiveObject,
  clearActiveObjects,
} from "../../../redux/actions/product2dActions"

/**
 * Container for buttons
 * @component
 *
 * @example
 * return (
 *  <ToggleProductContainer />
 * )
 */

const ToggleProductContainer = () => {
  const dispatch = useDispatch()
  const product2d = useSelector(state => state.product2d)
  const makFabric = useSelector(state => state.makFabric)
  const product2dActivePart = useSelector(state => state.product2dActivePart)
  const product2dCanvasState = useSelector(state => state.product2dCanvasState)

  const changeActivePart = ({target}) => {
    // ============================================need refactoring
    dispatch(
      setProduct2dCanvasState(
        product2dCanvasState.map(item =>
          item.name === product2dActivePart.name
            ? {
                name: item.name,
                state: makFabric.getCanvasState(),
              }
            : item,
        ),
      ),
    )

    makFabric.clearCanvas()

    dispatch(
      setProduct2dActivePart(
        product2d.parts.find(item => item.name === target.dataset.value),
      ),
    )

    let st = product2dCanvasState.find(
      item => item.name === target.dataset.value && item.state !== "",
    )

    if (st) {
      // console.log("LOAD STATE")
      makFabric.loadCanvasState(st.state)
    }

    dispatch(clearLeftWorkAreaState())
    dispatch(clearActiveObject())
    dispatch(clearActiveObjects())
  }

  return (
    <div className="toggleProductContainer">
      {product2d && product2d.parts.length !== 0 ? (
        product2d.parts.map(item => (
          <ToggleProdBtn
            key={item.name + Math.random() * 100}
            handler={changeActivePart}
            url={item.image}
            value={item.name}
            name={item.name}
            active={
              product2dActivePart && product2dActivePart.name === item.name
            }
          />
        ))
      ) : (
        <span>Products parts not found</span>
      )}
    </div>
  )
}

export default ToggleProductContainer
